import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { updateTipoUsuario } from "../../../redux/actions";
import SuccessModal from "../../../components/modals/successModal";
import ErrorModal from "../../../components/modals/errorModal";
import { useState } from "react";
import Button from "../../../components/button";

function CambiarTipoUsuarioComponent({ userId, onClose, onActualizacion }) {
    const dispatch = useDispatch();
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [errorModal, setErrorModal] = useState({ show: false, message: "" });
    const [loading, setLoading] = useState(false);
    const openErrorModal = (message) => setErrorModal({ show: true, message });
    const closeErrorModal = () => setErrorModal({ show: false, message: "" });

    const {
        register,
        handleSubmit,
    } = useForm();

    const onSubmit = async (data, event) => {
        event.preventDefault();
        setLoading(true);
        const finalData = { ...data, id: userId };
        try {
            const response = await dispatch(updateTipoUsuario(finalData));
            if (response) {
                setShowSuccessModal(true);
                if (typeof onActualizacion === "function") {
                    onActualizacion();
                }
            }
        } catch (error) {
            console.error(error);
            const serverErrorMessage = error.response?.data?.error || "Error inesperado al procesar la solicitud.";
            openErrorModal(serverErrorMessage);
        }
        setLoading(false);
    };

    const handleCloseSuccess = () => {
        setShowSuccessModal(false);
        onClose();
    };

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
            onClick={onClose} /* Cierra al hacer clic fuera */
        >
            {showSuccessModal && (
                <SuccessModal
                    closeSuccessModal={handleCloseSuccess}
                    message="Rol de usuario actualizado con éxito."
                />
            )}
            {errorModal.show && (
                <ErrorModal
                    closeErrorModal={closeErrorModal}
                    message={errorModal.message}
                />
            )}
            <form
                onSubmit={handleSubmit(onSubmit)}
                onClick={(e) =>
                    e.stopPropagation()
                } /* Evita que el clic dentro lo cierre */
            >
                <div className="w-[20rem] bg-white p-6 rounded-lg shadow-lg">
                    <div className="text-2xl font-bold mb-4 text-center">
                        Cambiar rol del usuario
                    </div>
                    <div className="mb-4">
                        <div className="block text-sm font-medium text-gray-700 mb-2">
                            Tipo
                        </div>

                        <select
                            className="w-full p-2 border rounded"
                            placeholder="Seleccionar un rol"
                            {...register("tipo", {
                                required: "Seleccione un rol por favor",
                            })}
                        >
                            <option value="" disabled>
                                Seleccionar un rol
                            </option>
                            <option value="super_admin">Super admin</option>
                            <option value="admin">Admin</option>
                            <option value="user">User</option>
                            <option value="viewer">Viewer</option>

                        </select>

                    </div>
                    <div className="flex flex-col justify-center gap-4">
                        <Button type="submit" fullWidth loading={loading}>
                            Guardar
                        </Button>
                        <Button
                            variant="secondary"
                            fullWidth
                            onClick={onClose}
                        >
                            Cancelar
                        </Button>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default CambiarTipoUsuarioComponent;
